import React from "react";
import "./FreeCounsellingForm.css";
import freecouncilling from "../Assets/novabridge-free-consultation-form.png"; // Adjust the path as necessary
const FreeCounsellingForm = () => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Generate years dynamically (current year + next 4 years)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear + i);

  // Combine month + year
  const options = [];
  years.forEach((year) => {
    months.forEach((month) => {
      options.push(`${month} ${year}`);
    });
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
  
    try {
      const response = await fetch("https://novaedubridge.com/form-handler.php", {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
  
      if (result.status === "success") {
        alert("Form submitted successfully!");
        e.target.reset();
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    }
  };
  

  return (
    <div className="container-fluid mx-auto free-counselling-wrapper">
      <div className="row g-0">
        {/* Left Side Form */}
        <div className="col-lg-6 form-container">
          <h2 className="form-title">
            <span className="blue-text"> Secure Your Admission to a Top  </span>
            <span className="red-text">University Abroad with Confidence</span>
          </h2>
          <p className="form-subtitle text-muted">
         Take the next step toward your global education journey with confidence. At Nova EduBridge, we guide you through every stage of the admission process, from selecting the right university to preparing and submitting strong applications.
Our team provides personalized support to ensure your profile meets the requirements of top universities abroad. With a structured approach and expert guidance, Nova EduBridge helps you achieve your goal of securing admission successfully while avoiding common mistakes.
          </p>

          <form onSubmit={handleSubmit}>
  {/* Name */}
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">First name*</label>
       <input type="text" name="firstName" className="form-control" required />
    </div>
    <div className="col">
      <label className="form-label">Last name*</label>
       <input type="text" name="lastName" className="form-control" required />
    </div>
  </div>

  {/* Email */}
  <div className="mb-3">
    <label className="form-label">Email address*</label>
    <input type="email" name="email" className="form-control" required />
  </div>

  {/* Mobile */}
  <div className="mb-3 d-flex align-items-end">
    <div className="flex-grow-1 me-2">
      <label className="form-label">Mobile number*</label>
       <input type="tel" name="phone" className="form-control" required />
    </div>
  </div>

  {/* Destination */}
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">Your preferred study destination*</label>
       <select name="destination" className="form-select" required>
        <option value="">-- Select Destination --</option>
        <option>UK</option>
        <option>USA</option>
        <option>New Zealand</option>
        <option>Ireland</option>
        <option>Dubai</option>
        <option>Singapore</option>
        <option>Switzerland</option>
        <option>Australia</option>
        <option>Canada</option>
        <option>Germany</option>
        <option>Europe</option>
        <option>France</option>
        <option>Netherlands</option>
        <option>Italy</option>
        <option>Poland</option>
        <option>Georgia</option>
        <option>Russia</option>
        <option>Kyrgyzstan</option>
        <option>Kazakhstan</option>
        <option>Uzbekistan</option>
         <option>Afghanistan</option>
        <option>Asia</option>
      </select>
    </div>
  </div>

  {/* Intake */}
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">Which intake you are planning for?*</label>
       <select name="intake" className="form-select" required>
        <option value="">-- Select Intake --</option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* Counselling Mode */}
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">Preferred mode of counselling*</label>
      <select name="counselling" className="form-select">
        <option>Online</option>
        <option>Offline</option>
      </select>
    </div>
  </div>

  {/* Course & Funding */}
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">Preferred course*</label>
       <select name="course" className="form-select" required>
         <option>UG</option>
        <option>MS</option>
        <option>MBA</option>
        <option>Medical</option>
        <option>Others</option>
      </select>
    </div>
    <div className="col">
      <label className="form-label">How would you fund your education?*</label>
       <select name="funding" className="form-select" required>
        <option value="">Select</option>
        <option value="self-funded">Self-Funded</option>
        <option value="family-support">Family Support</option>
        <option value="education-loan">Education Loan</option>
        <option value="scholarship">Scholarship</option>
        <option value="sponsorship">Sponsorship (Company/Government)</option>
        <option value="part-time-work">Part-Time Work</option>
        <option value="combination">Combination of Above</option>
        <option value="other">Other</option>
      </select>
    </div>
  </div>

  {/* Gender */}
  <div className="mb-3 d-flex align-items-center">
    <div className="form-check me-3">
      <input className="form-check-input" type="radio" name="gender" value="Male" />
      <label className="form-check-label">Male</label>
    </div>
    <div className="form-check">
      <input className="form-check-input" type="radio" name="gender" value="Female" />
      <label className="form-check-label">Female</label>
    </div>
  </div>

  {/* Date */}
  <div className="mb-3">
    <label className="form-label">Choose a Date</label>
   <input type="date" name="startDate" className="form-control" />
  </div>

  {/* Checkboxes */}
  <div className="form-check mb-2">
     <input className="form-check-input" type="checkbox" name="terms" required />
    <label className="form-check-label">I agree to Nova EduBridge Terms and privacy policy</label>
  </div>
  <div className="form-check mb-2">
    <input className="form-check-input" type="checkbox" name="contact" />
    <label className="form-check-label">Please contact me via whatsapp to assist with my enquiry</label>
  </div>
  <div className="form-check mb-4">
    <input className="form-check-input" type="checkbox" name="updates" />
    <label className="form-check-label">I would like to receive updates and offers from Nova EduBridge</label>
  </div>

  {/* Submit */}
  <button type="submit" className="btn btn-danger w-50 fw-bold">
    Submit
  </button>
</form>

        </div>

        {/* Right Side Image */}
        <div className="col-lg-6 image-container">
          <img
            src={freecouncilling}
            alt="Free Counselling"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
};

export default FreeCounsellingForm;
